export const TERMINOLOGY = {
  subject: 'Profile',
  subjectLower: 'profile',
  subjectPlural: 'Profiles',
  careSubject: 'Care Profile',
  careSubjectLower: 'care profile',
  switchSubject: 'Switch Profile',
  editSubject: 'Edit Profile',
  completeCareSubject: 'Complete Care Profile',
  careCircle: 'Care Circle',
  careCircleLower: 'care circle',
  careCirclePlural: 'Care Circles',
  careCirclePluralLower: 'care circles',
  careCircleMember: 'Care Circle Member',
  careCircleMemberLower: 'care circle member',
  careCircleMembers: 'Care Circle Members',
  careCircleMembersLower: 'care circle members',
};

export const formatPossessiveCareTeamLabel = (name) => (
  name ? `${name}'s ${TERMINOLOGY.careCircleLower}` : TERMINOLOGY.careCircle
);
